module.exports = __webpack_public_path__ + "static/media/icons8-full-screen.469b0b16.svg";